export default __webpack_public_path__ + "static/media/bg-wine.eb206c1e.jpg";